import { render, staticRenderFns } from "./await.vue?vue&type=template&id=5019e807&scoped=true&"
import script from "./await.vue?vue&type=script&lang=js&"
export * from "./await.vue?vue&type=script&lang=js&"
import style0 from "./await.vue?vue&type=style&index=0&id=5019e807&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019e807",
  null
  
)

export default component.exports